import { render, staticRenderFns } from "./BoardCards.vue?vue&type=template&id=d11f3962&scoped=true&"
import script from "./BoardCards.vue?vue&type=script&lang=js&"
export * from "./BoardCards.vue?vue&type=script&lang=js&"
import style0 from "./BoardCards.vue?vue&type=style&index=0&id=d11f3962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11f3962",
  null
  
)

export default component.exports